module.exports = __webpack_public_path__ + "static/media/no_permissions.f849acd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/NoPermissions/assets/no_permissions.svg
// module id = 1081
// module chunks = 0